import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		// Figma's warning surface (#FFF9E0 / #9D6506), which the theme names for the warning tag.
		alert: {
			backgroundColor: theme.palette.custom.tagWarningSurface,
			"& .MuiAlert-icon": {
				color: theme.palette.custom.tagWarningText,
			},
		},
		warning: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		// Figma keeps this inline link in the body colour; DialogLink adds the underline.
		link: {
			color: "inherit",
		},
		fieldLabel: {
			fontSize: 16,
			fontWeight: "bold",
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
			marginBottom: theme.spacing(3),
		},
	} satisfies Record<string, CSSObject>);
};
